import { ThemeProperties } from '../../core';

export interface DialogAlertTheme {
	background: string;
	borderRadius: string;
	boxShadow: string;
	padding: string;
	zIndex: string;
	maxWidth: string;

	innerPadding: string;

	headerText: string;
	headerTextAtMediumAndAbove: string;
	headerMarginBottom: string;

	bodyText: string;
	bodyTextAtMediumAndAbove: string;
	bodyMarginBottom: string;

	errorMarginBottom: string;

	buttonGroupGap: string;
}

export const theme = new ThemeProperties('dialogAlert');
